import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@material-ui/core';
import { Cancel, Done } from '@material-ui/icons';

interface IProps {
  title?: React.ReactNode;
  disabled?: boolean;
  onClose(): void;
  onConfirm(): void;
}

const ConfirmDialog: React.FC<IProps & Omit<DialogProps, 'title'>> = ({
  open,
  title,
  disabled,
  children,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="body">
      <DialogTitle>
        <b>Подтвердить</b>
      </DialogTitle>

      <DialogContent dividers>
        {title && <DialogContentText>{title}</DialogContentText>}

        {children}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" disabled={disabled} onClick={onClose} startIcon={<Cancel />}>
          Отменить
        </Button>

        <Button color="primary" variant="contained" disabled={disabled} onClick={onConfirm} startIcon={<Done />}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
